import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default {
	data() {
		return {
			isAuthorized: this.$store.state.isAuthorized,
			token: this.$store.getters.getToken,
			user: this.$store.state.user,
			db: {},
			error: {},
			authProgress: false,
			errorLogin: false,
			rules: {
		      required: value => !!value || 'This field is required',
		      email: value => {
		      	const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		        return pattern.test(value) || 'Wrong e-mail.'
		      },
		      safe: value => {
		        const pattern = /^[a-zA-Z0-9_]*$/
		        return pattern.test(value) || 'Wrong format'
		      },
		      password: value => {
		        const pattern = /^(?=.*[a-zA-Z])(?=.{6,})/
		        return pattern.test(value) || 'Password must be 6 characters or more and include lowercase and uppercase characters'
		      }
		    }
		}
	},
	methods: {
		checkAccountExistance(email) {
			return firebase.auth().fetchSignInMethodsForEmail(email)
		},
		currentUser() {
			if (!firebase.apps.length) {
				this.initApp()
			}
			return firebase.auth().currentUser
		},
		initApp() {
			const config = {
				apiKey: "AIzaSyB2IKwn8IgyKZj1tgtXRJiexyb3P2KPjik",
				authDomain: "yetcompany.firebaseapp.com",
				databaseURL: "https://yetcompany.firebaseio.com",
				projectId: "yetcompany",
				storageBucket: "yetcompany.appspot.com",
				messagingSenderId: "977363770464"
			};
			if (!firebase.apps.length) {
				firebase.initializeApp(config);
				firebase.auth().languageCode = 'ru';
				firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
				this.db = firebase.firestore();
			}
		},
		createNewUserByEmail(email, password) {
			return firebase.auth().createUserWithEmailAndPassword(email, password);
		},
		makeAuthByPwd(email, password) {
			this.authProgress = true;
			firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then( () => {
				firebase.auth().signInWithEmailAndPassword(email, password).then( (r) => {
					this.authProgress = false;
				}).catch( (err) => {
					this.error = err;
				});
			}).catch( (err) => {
				this.error = err;
			});
		},
		makeAuthByGoogle() {
			let provider = new firebase.auth.GoogleAuthProvider();
			provider.setCustomParameters({'prompt': 'consent'})
			this.authProgress = true;
			firebase.auth().signInWithPopup(provider).then( (r) => {
				this.authProgress = false;
				//this.user = r.user;
				//this.isAuthorized = true;
			}).catch( (err) => {
				this.error = err;
			});
		},
		deactivateAuth() {
			firebase.auth().signOut().then(() => {
			  this.$store.commit('makeUserDeauthorized');
			  //this.$router.push('/signin');
			}).catch((err) => {
				this.error = err;
			});
		},
		linkPasswordCredentials (password, hook) {
			hook = typeof hook !== 'undefinded'? hook:function(){}
			let credential = firebase.auth.EmailAuthProvider.credential(this.$store.state.user.email, password);
			firebase.auth().currentUser.linkAndRetrieveDataWithCredential(credential).then( (ucred) => {
				let user = ucred.user;
				console.log("Account linking success", user);
				hook()
			}, (err) => {
				console.log(err);
			});
		},
		linkGoogleCredentials (hook) {
			hook = typeof hook !== 'undefined'? hook:function(){}
			let provider = new firebase.auth.GoogleAuthProvider();
			firebase.auth().currentUser.linkWithPopup(provider).then( (ucred) => {
				let user = ucred.user;
				console.log("Account linking success", user);
				hook()
			}, (err) => {
				console.log(err);
			});
		}
	},
	computed: {
		appdb() {
			return Object.keys(this.db) == 0 ? firebase.firestore(): this.db;
		}
	}
}